import { Button, Drawer, Tabs, Upload, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Icon from '@components/Icon';
import ColorPicker from '@components/ColorPicker';
import stores from '@stores';
import colorSvg from '@assets/color.svg';
import { BackgroundSelect } from './BackgroundSelect';
import { useState } from 'react';

export default observer(({ showMore, onChange }) => {
    const { t } = useTranslation('toolbar');
    const [activeKey, setActiveKey] = useState('1');
    const [customImageUrl, setCustomImageUrl] = useState('');
    
    const onMoreClose = () => {
        onChange(false);
    }
    
    const handleCustom = (e) => {
        const color = e.toHexString();
        stores.option.frameConf.background = {
            type: 'solid',
            color
        }
    }
    
    const onSelectChange = (key) => {
        stores.option.setBackground(key);
    }
    
    const handleCustomImage = (info) => {
        if (info.file.status === 'done') {
            // 获取上传的图片URL
            const imageUrl = URL.createObjectURL(info.file.originFileObj);
            setCustomImageUrl(imageUrl);
            
            // 设置自定义图片作为背景
            stores.option.frameConf.background = {
                type: 'image',
                url: imageUrl
            };
            
            // 创建一个自定义背景键，使其在option.background中也能够跟踪
            const customKey = `custom_img_${Date.now()}`;
            
            // 设置自定义背景到option store
            stores.option.background = customKey;
            message.success(t('background.uploadSuccess'));
        } else if (info.file.status === 'error') {
            message.error(t('background.uploadError'));
        }
    }
    
    const tabItems = [
        {
            key: '1',
            label: t('background.tabs.solid'),
            children: (
                <>
                    <div className="py-2 flex items-center gap-2">
                        <ColorPicker onChange={handleCustom}>
                            <Button type="default" className="flex items-center" icon={<img src={colorSvg} width={18} className="mr-1" />}>
                                {t('background.customColor')}
                            </Button>
                        </ColorPicker>
                    </div>
                    <div className="py-2">
                        <BackgroundSelect type="solid" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '2',
            label: t('background.tabs.gradient'),
            children: (
                <>
                    <div className="py-2">
                        <p className="text-xs text-gray-500 mb-2">{t('background.gradientDescription')}</p>
                        <BackgroundSelect type="gradient" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '3',
            label: t('background.tabs.texture'),
            children: (
                <>
                    <div className="py-2">
                        <p className="text-xs text-gray-500 mb-2">{t('background.textureDescription')}</p>
                        <BackgroundSelect type="texture" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '4',
            label: t('background.tabs.image'),
            children: (
                <>
                    <div className="py-2">
                        <h4 className="text-sm font-bold py-1">{t('background.uploadImage.title')}</h4>
                        <p className="text-xs text-gray-500 mb-2">{t('background.uploadImage.description')}</p>
                        <Upload.Dragger
                            name="file"
                            multiple={false}
                            showUploadList={false}
                            customRequest={({ file, onSuccess }) => {
                                setTimeout(() => {
                                    onSuccess("ok");
                                }, 0);
                            }}
                            onChange={handleCustomImage}
                            accept="image/png,image/jpeg,image/webp"
                        >
                            {customImageUrl ? (
                                <div className="w-full p-2">
                                    <img src={customImageUrl} alt={t('background.uploadImage.alt')} className="w-full rounded-md" />
                                    <p className="text-xs text-gray-500 mt-1">{t('background.uploadImage.changeImage')}</p>
                                </div>
                            ) : (
                                <div className="p-4">
                                    <p className="ant-upload-drag-icon">
                                        <Icon.ImagePlus size={28} className="text-purple-500" />
                                    </p>
                                    <p className="text-sm">{t('background.uploadImage.uploadHint')}</p>
                                    <p className="text-xs text-gray-500">{t('background.uploadImage.formatSupport')}</p>
                                </div>
                            )}
                        </Upload.Dragger>
                    </div>
                    <h4 className="text-sm font-bold py-2 mt-2">{t('background.recommendedImages.title')}</h4>
                    <p className="text-xs text-gray-500 mb-2">{t('background.recommendedImages.description')}</p>
                    <BackgroundSelect type="recommend" onChange={onSelectChange} value={stores.option.background} />
                </>
            )
        }
    ];
    
    return (
        <Drawer
            title={t('background.title')}
            placement="right"
            closable={true}
            mask={false}
            onClose={onMoreClose}
            open={showMore}
            getContainer={false}
            width="100%"
            extra={
                <Button
                    type="text"
                    size="small"
                    className="text-xs flex items-center opacity-80 m-0"
                    onClick={() => onChange(false)}
                >
                    {t('background.back')}
                </Button>
            }
            className="backdrop-drawer"
        >
            <div className="flex flex-col gap-2 h-full overflow-hidden">
                <div className="h-0 flex-1 overflow-y-auto px-2 py-2">
                    <Tabs
                        activeKey={activeKey}
                        onChange={setActiveKey}
                        items={tabItems}
                        className="bg-settings-tabs"
                    />
                </div>
            </div>
        </Drawer>
    )
});
